module.exports = __webpack_public_path__ + "img/PL08202.2fc3adc1.png";